<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300" (click)="closeDropdowns()">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight flex items-center gap-3">
        รายงานข้อมูลบัตรสมาชิก
        <span class="text-sm font-black text-amber-600 bg-amber-50 dark:bg-amber-900/30 px-2.5 py-1 rounded-lg">RPPK14</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ชื่อบัตร · ชื่อ-สกุล · ทะเบียน · ประเภทสมาชิก · ประเภทรถ — จัดกลุ่มตามประเภทรถ
      </p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 no-print">
      <div *ngIf="lastFetchedTime"
        class="flex flex-col items-end justify-center text-right shrink-0 w-[112px] h-[46px]">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1 whitespace-nowrap">ดึงข้อมูลล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">{{ lastFetchedTime | date:'HH:mm:ss' }}</span>
      </div>
      <button type="button" (click)="onRefresh()" [disabled]="!canSearch || isLoading()" title="รีเฟรช"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 transition-all flex items-center justify-center cursor-pointer disabled:opacity-40">
        <span class="material-icons">refresh</span>
      </button>
      <button type="button" (click)="onExportExcel()"
        [disabled]="groups.length === 0 || isLoading() || isExporting()"
        class="px-4 py-3 bg-white/95 dark:bg-slate-800/95 text-emerald-600 dark:text-emerald-400 font-bold rounded-2xl shadow-sm border border-emerald-100 dark:border-emerald-900 hover:bg-emerald-50 transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40">
        <span class="material-icons text-[18px]">table_view</span>
        {{ isExporting() ? 'กำลังส่งออก...' : 'ส่งออก Excel' }}
      </button>
      <button type="button" (click)="onPrintPdf()"
        [disabled]="!hasSearched() || isLoading() || isProcessingPdf()"
        class="px-4 py-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
        <span class="material-icons text-[18px]">picture_as_pdf</span>
        {{ isProcessingPdf() ? 'กำลังสร้าง PDF...' : 'ดูแบบ PDF' }}
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 space-y-4 no-print">
      <div class="flex flex-wrap items-center gap-2">
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">badge</span>
          เงื่อนไขรายงาน
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="text-xs font-semibold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-lg">
          {{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div *ngIf="!selectedSiteId"
        class="rounded-2xl border border-amber-200 dark:border-amber-800 bg-amber-50/80 dark:bg-amber-900/20 px-4 py-3 text-sm font-medium text-amber-800 dark:text-amber-300">
        กรุณาเลือกลานจาก Navbar ก่อน
      </div>

      <div class="flex flex-wrap gap-2">
        <button *ngFor="let opt of statusOptions" type="button" (click)="selectStatus(opt)"
          class="px-3 py-1.5 rounded-xl text-xs font-bold border transition-all cursor-pointer"
          [ngClass]="statusFilter === opt.id
            ? 'bg-amber-400 border-amber-400 text-slate-900'
            : 'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-500'">
          {{ opt.label }}
        </button>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
        <div class="relative" (click)="$event.stopPropagation()">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ค้นหา</label>
          <div class="flex h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 overflow-hidden bg-slate-50 dark:bg-slate-900 focus-within:ring-2 focus-within:ring-amber-200">
            <button type="button" (click)="isSearchTypeDropdownOpen = !isSearchTypeDropdownOpen"
              class="px-3 text-xs font-bold text-slate-500 border-r border-slate-200 dark:border-slate-700 shrink-0 cursor-pointer">
              {{ searchTypeLabel }}
            </button>
            <input type="text" [(ngModel)]="searchText" (ngModelChange)="onFilterChange()"
              placeholder="พิมพ์คำค้น..."
              class="flex-1 min-w-0 bg-transparent px-3 font-bold text-sm text-slate-700 dark:text-slate-200 focus:outline-none border-none">
          </div>
          <div *ngIf="isSearchTypeDropdownOpen"
            class="absolute z-30 mt-1 left-0 w-40 rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg overflow-hidden">
            <button *ngFor="let opt of searchTypeOptions" type="button" (mousedown)="$event.preventDefault()" (click)="selectSearchType(opt)"
              class="w-full text-left px-3 py-2 text-xs font-semibold hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer border-none bg-transparent"
              [ngClass]="searchType === opt.id ? 'text-amber-600' : 'text-slate-600 dark:text-slate-300'">
              {{ opt.label }}
            </button>
          </div>
        </div>

        <div class="relative" (click)="$event.stopPropagation()">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทรถ</label>
          <input type="text" [(ngModel)]="searchVehicleTypeText"
            (focus)="isVehicleTypeDropdownOpen = true"
            (ngModelChange)="isVehicleTypeDropdownOpen = true"
            placeholder="ทุกประเภทรถ"
            class="w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-3 font-bold text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200">
          <div *ngIf="isVehicleTypeDropdownOpen"
            class="absolute z-30 mt-1 w-full max-h-52 overflow-auto rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg custom-scrollbar">
            <button type="button" (mousedown)="$event.preventDefault()" (click)="clearVehicleType()"
              class="w-full text-left px-3 py-2 text-xs font-semibold text-amber-600 hover:bg-amber-50 cursor-pointer border-none bg-transparent">ทุกประเภทรถ</button>
            <button *ngFor="let opt of filteredVehicleTypes" type="button" (mousedown)="$event.preventDefault()" (click)="selectVehicleType(opt)"
              class="w-full text-left px-3 py-2 text-xs font-semibold hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer border-none bg-transparent text-slate-700 dark:text-slate-200">
              {{ opt.typeName }}
            </button>
          </div>
        </div>

        <div class="relative" (click)="$event.stopPropagation()">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">ประเภทสมาชิก</label>
          <input type="text" [(ngModel)]="searchSubscriptionText"
            (focus)="isSubscriptionDropdownOpen = true"
            (ngModelChange)="isSubscriptionDropdownOpen = true"
            placeholder="ทุกประเภทสมาชิก"
            class="w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-3 font-bold text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200">
          <div *ngIf="isSubscriptionDropdownOpen"
            class="absolute z-30 mt-1 w-full max-h-52 overflow-auto rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg custom-scrollbar">
            <button type="button" (mousedown)="$event.preventDefault()" (click)="clearSubscription()"
              class="w-full text-left px-3 py-2 text-xs font-semibold text-amber-600 hover:bg-amber-50 cursor-pointer border-none bg-transparent">ทุกประเภทสมาชิก</button>
            <button *ngFor="let opt of filteredSubscriptions" type="button" (mousedown)="$event.preventDefault()" (click)="selectSubscription(opt)"
              class="w-full text-left px-3 py-2 text-xs font-semibold hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer border-none bg-transparent text-slate-700 dark:text-slate-200">
              {{ opt.name }}
            </button>
          </div>
        </div>

        <div class="relative" (click)="$event.stopPropagation()">
          <label class="block text-xs font-bold text-slate-400 uppercase tracking-wider mb-2">บริษัทผู้เช่า</label>
          <input type="text" [(ngModel)]="searchClientText"
            (focus)="isClientDropdownOpen = true"
            (ngModelChange)="isClientDropdownOpen = true"
            placeholder="ทุกบริษัท"
            class="w-full h-[46px] rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 px-3 font-bold text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-amber-200">
          <div *ngIf="isClientDropdownOpen"
            class="absolute z-30 mt-1 w-full max-h-52 overflow-auto rounded-xl border border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 shadow-lg custom-scrollbar">
            <button type="button" (mousedown)="$event.preventDefault()" (click)="clearClient()"
              class="w-full text-left px-3 py-2 text-xs font-semibold text-amber-600 hover:bg-amber-50 cursor-pointer border-none bg-transparent">ทุกบริษัท</button>
            <button *ngFor="let opt of filteredClients" type="button" (mousedown)="$event.preventDefault()" (click)="selectClient(opt)"
              class="w-full text-left px-3 py-2 text-xs font-semibold hover:bg-amber-50 dark:hover:bg-slate-700 cursor-pointer border-none bg-transparent text-slate-700 dark:text-slate-200">
              {{ opt.name }}
            </button>
          </div>
        </div>
      </div>

      <div class="flex justify-end">
        <button type="button" (click)="onSearch()" [disabled]="!canSearch || isLoading()"
          class="h-[46px] px-6 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold rounded-xl shadow-sm transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-40 border-none">
          <span class="material-icons text-[20px]">search</span>
          {{ isLoading() ? 'กำลังโหลด...' : 'ค้นหา' }}
        </button>
      </div>
    </div>

    <div class="min-h-[280px] relative p-4 md:p-6 space-y-6" [class.opacity-50]="isLoading()">
      <div *ngIf="!isLoading() && !hasSearched()" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">search</span>
        <p class="font-bold">เลือกเงื่อนไข แล้วกดค้นหา</p>
      </div>

      <div *ngIf="hasSearched() && !isLoading() && groups.length === 0" class="py-16 text-center text-slate-400">
        <span class="material-icons text-4xl mb-2 block opacity-40">search_off</span>
        <p class="font-bold">ไม่พบข้อมูลตามเงื่อนไข</p>
      </div>

      <ng-container *ngFor="let vt of groups">
        <div class="rounded-2xl border border-slate-100 dark:border-slate-700 overflow-hidden">
          <div class="px-4 py-2.5 bg-slate-100 dark:bg-slate-900/80 border-b border-slate-100 dark:border-slate-700 font-bold text-slate-800 dark:text-slate-100">
            ประเภทรถ: {{ vt.vehicleTypeName }}
          </div>

          <div *ngFor="let sub of vt.subscriptions" class="border-b border-slate-100 dark:border-slate-700 last:border-b-0">
            <div class="px-4 py-2 bg-amber-50/70 dark:bg-amber-950/20 flex flex-wrap gap-x-4 gap-y-1 text-xs font-bold text-slate-700 dark:text-slate-200">
              <span>ประเภทสมาชิก: {{ sub.subscriptionName }}</span>
              <span class="text-amber-700 dark:text-amber-300">รวมบัตร: {{ sub.cardCount | number }} ใบ</span>
            </div>
            <div class="overflow-x-auto custom-scrollbar">
              <table class="w-full text-left border-collapse min-w-[1100px] text-[11px]">
                <thead class="bg-white/95 dark:bg-slate-800/95">
                  <tr class="text-[10px] font-bold text-slate-400 uppercase tracking-wider whitespace-nowrap text-center">
                    <th class="p-2 border border-slate-100 dark:border-slate-700">ลำดับที่</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">ชื่อบัตร</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">ชื่อ - สกุล</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">ทะเบียนรถ</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">ประเภทสมาชิก</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700">สถานะบัตร</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700">วันที่เริ่มใช้บัตร</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700">วันที่หมดอายุ</th>
                    <th class="p-2 border border-slate-100 dark:border-slate-700 text-left">บริษัทผู้เช่า</th>
                  </tr>
                </thead>
                <tbody class="tabular-nums">
                  <tr *ngFor="let c of sub.cards" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40">
                    <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">{{ c.seq }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700 font-semibold text-sky-700 dark:text-sky-300">{{ c.cardName }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700">{{ c.fullName }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700">{{ c.licenses }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700">{{ c.subscriptionName }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700 text-center">{{ c.statusName }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700 text-center whitespace-nowrap">{{ formatDateTime(c.issueDate) }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700 text-center whitespace-nowrap">{{ formatDateTime(c.expireDate) }}</td>
                    <td class="p-2 border border-slate-50 dark:border-slate-700">{{ c.clientName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="totals && groups.length > 0"
        class="rounded-2xl border-2 border-amber-200 dark:border-amber-800 bg-amber-50/50 dark:bg-amber-950/20 px-5 py-4 flex flex-wrap items-center justify-between gap-3 font-bold">
        <span class="text-slate-700 dark:text-slate-200">สรุปรวมทั้งรายงาน</span>
        <div class="flex flex-wrap gap-5 tabular-nums text-sm">
          <span>บัตร: <span class="text-amber-700 dark:text-amber-300 text-lg">{{ totals.cardCount | number }}</span> ใบ</span>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal-invoice-pdf-viewer
  *ngIf="showPdfModal()"
  [pdfSrc]="pdfSrc"
  [modalTitle]="'RPPK14 — รายงานข้อมูลบัตรสมาชิก (PDF)'"
  [downloadFileName]="pdfDownloadName"
  (close)="closePdfModal()">
</app-modal-invoice-pdf-viewer>

<app-pss-loading *ngIf="isLoading()"></app-pss-loading>
